import {
  ApplicationConfig,
  APP_INITIALIZER,
  CSP_NONCE,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { icons } from './icons-provider';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';
import { DBConfig, provideIndexedDb } from 'ngx-indexed-db';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { AppInitService } from './services/app-init.service';
import { SessionInterceptor } from './interceptors/session.interceptor';
import { NZ_GLOBAL_CONFIG } from './nz-global-config';

registerLocaleData(en);

const dbConfig: DBConfig = {
  name: 'MyDb',
  version: 7,
  objectStoresMeta: [
    {
      store: 'messages',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'userId', keypath: 'userId', options: { unique: false } },
        { name: 'text', keypath: 'text', options: { unique: false } },
        { name: 'sender', keypath: 'sender', options: { unique: false } },
        { name: 'roomId', keypath: 'roomId', options: { unique: false } },
        { name: 'timestamp', keypath: 'timestamp', options: { unique: false } },
      ],
    },
    {
      store: 'conversations',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'userId', keypath: 'userId', options: { unique: false } },
        { name: 'createdAt', keypath: 'createdAt', options: { unique: false } },
        { name: 'name', keypath: 'name', options: { unique: false } },
        { name: 'summery', keypath: 'summery', options: { unique: false } },
        { name: 'icd', keypath: 'icd', options: { unique: false } },
        { name: 'files', keypath: 'files', options: { unique: false } },
      ],
    },
  ],
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNzIcons(icons),
    provideNzI18n(en_US),
    provideNzConfig(NZ_GLOBAL_CONFIG),
    importProvidersFrom(FormsModule, NzModalModule),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideMarkdown(),
    provideIndexedDb(dbConfig),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
    { provide: CSP_NONCE, useValue: 'amplify_nonce' },
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitService: AppInitService) => () =>
        appInitService.initializeApp(),
      deps: [AppInitService],
      multi: true,
    },
  ],
};
